import React from 'react';
import AddToCartContainer from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/AddToCartContainer';
import { BookButtonState } from 'component/page/detail/PackageOptions/ExpandedOffer/OfferCardBookButtonSection/BookButtonContainer';

interface ConditionalAddToCartButtonProps {
    isCartEligible: boolean;
    isSearchCriteriaUpdated: boolean;
    width: 'parent-fit' | 'content-fit';
    hasOnlyDisabledOptions: boolean;
    bookButtonState: BookButtonState;
}
const ConditionalAddToCartButton: React.FC<ConditionalAddToCartButtonProps> = (props) => {
    const isButtonDisabled = props.hasOnlyDisabledOptions || props.isSearchCriteriaUpdated || props.bookButtonState !== BookButtonState.Enabled;
    return <AddToCartContainer buttonWidth={props.width} isAddToCartEnabled={props.isCartEligible} disabled={isButtonDisabled} />;
};

ConditionalAddToCartButton.displayName = 'ConditionalAddToCartButton';

export default ConditionalAddToCartButton;
